import localforage from 'localforage';

export default function configureApp( app ) {

  localforage.config( {
    name        : 'swiper-storage',
    description : 'Swiper Storage',
  } );

  app.storage = localforage;
}
